import { create } from "zustand";

interface Brand {
  Id: number;
  BrandId: string | null;
  BrandName: string;
  OutletId: string | null;
  OutletName: string;
  CreatedDate: string;
}

interface CampaignInfo {
  Email: string;
  MemberPortalUrl: string;
  BrandName: string;
  Currency?: string;
}

interface BrandStore {
  brandId: string | null;
  brands: Brand[];
  campaignInfo: CampaignInfo | null;
  setBrandId: (id: string | null) => void;
  setBrands: (brands: Brand[]) => void;
  setCampaignInfo: (info: CampaignInfo | null) => void;
}

export const useBrandStore = create<BrandStore>((set) => ({
  brandId: null, // Initially null
  brands: [],
  campaignInfo: null,
  setBrandId: (id) => set({ brandId: id }),
  setBrands: (brands) =>
    set((state) => ({
      brands,
      //brandId: brands.length > 0 ? brands[0]?.BrandId || null : state.brandId, // Set first brandId automatically
    })),
  setCampaignInfo: (info) => set({ campaignInfo: info }),
}));
